import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "keyConnect"
const KeyConnectIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.21 12.388C6.625 12.423 6.93 12.787 6.895 13.2 6.81 14.156 6.812 15.117 6.896 16.073 6.932 16.485 6.627 16.849 6.215 16.886S5.438 16.617 5.402 16.205C5.31 15.162 5.309 14.113 5.399 13.07 5.435 12.658 5.8 12.352 6.211 12.387" />
          <path
            fillRule="evenodd"
            d="M2.555 10.607C2.884 9.57 3.92 9.03 4.917 9.182L10.577 10.047C11.55 10.195 12.355 10.8 12.785 11.625H19.074C19.545 11.625 19.989 11.847 20.273 12.223L21.938 14.437 20.273 16.653C19.989 17.028 19.545 17.25 19.073 17.25H12.949C12.586 18.262 11.694 19.033 10.578 19.203L4.912 20.068C3.917 20.22 2.884 19.684 2.555 18.65 2.25 17.692 1.875 16.203 1.875 14.638 1.875 13.07 2.25 11.57 2.555 10.607M4.69 10.666C4.344 10.612 4.068 10.8 3.986 11.06 3.703 11.954 3.376 13.287 3.375 14.637 3.375 15.986 3.701 17.31 3.984 18.196 4.066 18.452 4.34 18.638 4.685 18.585L10.351 17.721C10.711 17.666 11.024 17.485 11.25 17.229V12.02C11.024 11.764 10.71 11.585 10.351 11.53zM13.125 15.75H15V14.25C15.828 14.25 16.5 14.922 16.5 15.75H17.25V14.25C18.078 14.25 18.75 14.922 18.75 15.75H19.074L20.06 14.438 19.074 13.125H13.125z"
            clipRule="evenodd"
          />
          <path d="M12.068 5.25C13.238 5.265 14.378 5.62 15.348 6.273 15.693 6.502 15.784 6.969 15.553 7.312S14.855 7.748 14.512 7.517C13.784 7.026 12.928 6.76 12.052 6.75 11.173 6.74 10.311 6.987 9.572 7.46 9.225 7.683 8.761 7.581 8.538 7.233 8.315 6.883 8.416 6.42 8.765 6.197 9.75 5.567 10.898 5.237 12.068 5.251" />
          <path d="M12 2.25C12.985 2.25 13.96 2.444 14.87 2.82 15.78 3.198 16.607 3.75 17.304 4.448 17.596 4.739 17.596 5.214 17.304 5.507 17.01 5.8 16.536 5.8 16.243 5.507 15.686 4.95 15.024 4.51 14.296 4.207 13.568 3.906 12.788 3.75 12 3.75S10.432 3.906 9.704 4.207 8.314 4.95 7.757 5.507C7.464 5.8 6.99 5.8 6.697 5.507S6.404 4.74 6.697 4.447C7.393 3.75 8.22 3.197 9.13 2.82 10.04 2.444 11.015 2.25 12 2.25" />
        </svg>
      }
    </span>
  )
}
export default KeyConnectIcon
